import React from 'react';
import { draftEvents, upcomingEvents, archivedEvents } from "../api/FirebaseAPI";
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryText,
  ListItemMeta
} from 'rmwc/List';


import moment from 'moment';
import { TabBar, Tab } from 'rmwc/Tabs';

class MyEventsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      events:[],
      activeTabIndex:0
    }
    this.handleTabChanged = this.handleTabChanged.bind(this)
    this._loadEvents = this._loadEvents.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)

    this.elementCount = 50
  }

  static draftId = 0;
  static upcomingId = 1;
  static archivedId = 2;


  componentWillMount() {
    this._loadEvents(this.state.activeTabIndex)
  }

  _loadEvents(tabId) {
    switch (tabId) {
      case 0:
        draftEvents(50)
        .then(result => {
            this.setState({events: result});
        })
        break;
      case 1:
        upcomingEvents(50)
        .then(result => {
            this.setState({events: result});
        })
        break;
      case 2:
        archivedEvents(this.elementCount + 1)
        .then(result => {
            this.setState({events: result});
        })
        break;
      default: throw new Error("Undefined activeTabIndex");
    }
  }

  handleTabChanged(evt) {
    let tabId = evt.detail.activeTabIndex;
    this.setState({'activeTabIndex': tabId})
    this._loadEvents(tabId);
  }

  handleClickNext() {
    let startFromId = this.state.events[this.state.events.length-1]
    archivedEvents(4, startFromId, "next")
    .then(result => {this.setState({events: result});})
  }

  handleClickPrevious() {
    let startFromId = this.state.events[this.state.events.length-1]
    archivedEvents(4, startFromId, "previous")
    .then(result => {this.setState({events: result});})
  }

  renderDate(evt) {
    if (evt._c) {
      return (
        <div>
        {moment(evt.startDate).format("D MMM, YYYY h:mm a")}
        "  ------ Created:" {moment(evt._c).format("YYYY/MM/DD h:mm a")}
        </div>
      )
    } else {
      return (
        <div>
        {moment(evt.startDate).format("D MMM, YYYY h:mm a")}
        </div>
      )
    }

  }

  renderEventListItem(evt) {
    return (
      <ListItem key={evt.id}>
        <ListItemText>
          <a href={"./events/" + evt.id + "/edit"} style={{textDecoration: "none"}}>
            {evt.title}
          </a>
          <ListItemSecondaryText>
            {this.renderDate(evt)}
          </ListItemSecondaryText>
        </ListItemText>
        <ListItemMeta>info</ListItemMeta>
      </ListItem>
    )
  }

  renderTab() {
    return (
      <TabBar
        activeTabIndex={this.state.activeTabIndex}
        onChange={this.handleTabChanged}
      >
        <Tab>Draft</Tab>
        <Tab>Future</Tab>
        <Tab>Archived</Tab>
      </TabBar>

    )
  }

  render() {
    return (
      <div>
        My Events Page
        {this.renderTab()}
        <List>
          {this.state.events.map(evt =>
            this.renderEventListItem(evt)
          )}
        </List>
      </div>
    );
  }
}

export default MyEventsPage;

/**/



// WEBPACK FOOTER //
// ./src/containers/MyEventsPage.js